import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  crearProveedor,
  actualizarProveedor,
} from "../service/proveedoresService";

const ProveedorFormModal = ({ open, onClose, proveedor, refresh, showToast }) => {
  const [nombre, setNombre] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setNombre(proveedor?.nombre || "");
    setError("");
  }, [proveedor, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) {
      setError("El nombre es obligatorio");
      return;
    }
    setSaving(true);
    try {
      if (proveedor) {
        await actualizarProveedor(proveedor.id, nombre.trim());
        showToast("Proveedor actualizado.", "success");
      } else {
        await crearProveedor(nombre.trim());
        showToast("Proveedor creado.", "success");
      }
      await refresh();
      onClose();
    } catch (err) {
      showToast(err.message || "Error al guardar el proveedor.", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main" }}>
          {proveedor ? "Editar proveedor" : "Nuevo proveedor"}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <TextField
            autoFocus
            fullWidth
            label="Nombre del proveedor"
            value={nombre}
            onChange={(e) => {
              setNombre(e.target.value);
              if (error) setError("");
            }}
            error={!!error}
            helperText={error}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={saving}>
            {proveedor ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProveedorFormModal;
